import React from 'react';

import { ErrorBoundary } from '@lumapps/utils/components/ErrorBoundary';

import { NavigationItemDetails as NavigationItemDetailsUI, NavigationItemDetailsParams } from './NavigationItemDetails';
import { NavigationNodeDetailsError } from './NavigationNodeDetailsError';

/**
 * Navigation item details with an error boundary to avoid
 * breaking the whole page if something goes wrong
 */
export const NavigationItemDetails: React.FC<NavigationItemDetailsParams> = (props) => {
    return (
        <ErrorBoundary fallback={<NavigationNodeDetailsError />}>
            <NavigationItemDetailsUI {...props} />
        </ErrorBoundary>
    );
};
